import { __assign } from "tslib";
import { SearchDocumentType } from '../sdk';
var MAX_SUGGEST_QUERY_LENGTH = 100;
var BASE_API_URL = '/_api/search-services-reader';
var CORRELATION_ID_HEADER_NAME = 'x-wix-search-bi-correlation-id';
export var API_URL_SEARCH = "".concat(BASE_API_URL, "/v1/search");
export var API_URL_SUGGEST_FEDERATED = "".concat(BASE_API_URL, "/v1/suggest/federated");
export var API_URL_TRENDING = "".concat(BASE_API_URL, "/v1/trending");
export var API_URL_SEARCH_FEDERATED = "".concat(BASE_API_URL, "/v1/search/federated");
export var API_URL_AUTOCOMPLETE_FEDERATED = "".concat(BASE_API_URL, "/v1/autocomplete/federated");
var SearchApi = /** @class */ (function () {
    function SearchApi(_a) {
        var httpClient = _a.httpClient, timeout = _a.timeout;
        this.httpClient = httpClient;
        this.requestOptions = { timeout: timeout };
    }
    SearchApi.prototype.getFieldsByDocumentType = function (searchRequest) {
        var _a;
        if (!searchRequest.documentType) {
            return;
        }
        var fieldsByDocumentType = (_a = {},
            _a[SearchDocumentType.Products] = ['currency', 'discountedPrice', 'inStock'],
            _a[SearchDocumentType.Events] = [
                'currency',
                'eventType',
                'location',
                'maxPrice',
                'minPrice',
                'startDate',
            ],
            _a[SearchDocumentType.Forums] = [
                'contentType',
                'categoryTitle',
                'createdDate',
                'totalComments',
                'viewCount',
                'likeCount',
                'upvoteCount',
                'downvoteCount',
                'parentId',
            ],
            _a);
        var extraFields = fieldsByDocumentType[searchRequest.documentType] || [];
        return ['description', 'title', 'id'].concat(extraFields);
    };
    SearchApi.prototype.getHeaders = function (params) {
        var _a;
        return (params === null || params === void 0 ? void 0 : params.correlationId)
            ? (_a = {}, _a[CORRELATION_ID_HEADER_NAME] = params.correlationId, _a) : {};
    };
    SearchApi.prototype.search = function (searchRequest, requestParams) {
        var data = __assign(__assign({}, searchRequest), { fuzzy: true, fields: this.getFieldsByDocumentType(searchRequest) });
        return this.httpClient.post(API_URL_SEARCH, data, __assign(__assign({}, this.requestOptions), { headers: this.getHeaders(requestParams) }));
    };
    SearchApi.prototype.getFederatedSuggestions = function (suggestionsRequest, requestParams) {
        var data = __assign(__assign({}, suggestionsRequest), { query: suggestionsRequest.query.substring(0, MAX_SUGGEST_QUERY_LENGTH) });
        return this.httpClient.post(API_URL_SUGGEST_FEDERATED, data, __assign(__assign({}, this.requestOptions), { headers: this.getHeaders(requestParams) }));
    };
    SearchApi.prototype.getTrendingItems = function (trendingRequest, requestParams) {
        return this.httpClient.post(API_URL_TRENDING, trendingRequest, __assign(__assign({}, this.requestOptions), { headers: this.getHeaders(requestParams) }));
    };
    SearchApi.prototype.getFederatedAutocomplete = function (autocompleteRequest, requestParams) {
        return this.httpClient.post(API_URL_AUTOCOMPLETE_FEDERATED, autocompleteRequest, __assign(__assign({}, this.requestOptions), { headers: this.getHeaders(requestParams) }));
    };
    SearchApi.prototype.getSample = function (sampleRequest, requestParams) {
        var data = __assign(__assign({}, sampleRequest), { fuzzy: true });
        return this.httpClient.post(API_URL_SEARCH_FEDERATED, data, __assign(__assign({}, this.requestOptions), { headers: this.getHeaders(requestParams) }));
    };
    return SearchApi;
}());
export { SearchApi };
//# sourceMappingURL=api.js.map